import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// IMPORT MEDICAL MODULE COMPONENTS
import { MainMedicalComponent } from './main-medical.component';
import { FormComponent } from '../form/form.component';
import { PoctTestFormComponent } from '../poct-test-form/poct-test-form.component';
import { BreathAlcoholFormComponent } from '../breath-alcohol-form/breath-alcohol-form.component';




const routes: Routes = [

  {
    path: '',
    component: MainMedicalComponent,
    children: [

      {
        path: 'add/:jobId',
        component: FormComponent
      },
      {
        path: 'breathAlcohol/:jobId',
        component: BreathAlcoholFormComponent
      },
      {
        path: 'testPoct/:jobId',
        component: PoctTestFormComponent
      },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainMedicalRoutingModule { }
